module.exports = __webpack_public_path__ + "img/facebook-logo.d1e49276.svg";